
import ReactApexChart from 'react-apexcharts';
import { moneyFormat } from '../Helper/helper';
export const barChart = (series,y='£ (thousands)',toolTipType=1,height=400) =>{
    if(series[0].x==null){
      series.x=['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug']
    }
    console.log("series---", series);
    if(y==null)y='Revenue (£)'
     const options = {
              chart: {
                type: 'bar',
                stacked: true,
              },
              colors: ['#C0031B', '#545454'],
              plotOptions: {
                bar: {
                  // borderRadius:10,
                  horizontal: false,
                  columnWidth: '55%',
                  endingShape: 'rounded'
                },
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
              },
              xaxis: {
                categories: series[0].x,
               
              },
              yaxis: {
                title: {
                  text: y
                }
              },
              fill: {
                opacity: 1
              },
              tooltip: {
                y: {
                  formatter: function (val) {
                    return toolTipType==1?  moneyFormat(val) + "": val
                  }
                }
              }
            }
              
     return (
       <div>
          <ReactApexChart options={options} series={series} type="bar" height  ={height} />
       </div>
     )

  }